import { render, staticRenderFns } from "./OtoCoupon.vue?vue&type=template&id=1bb76757&scoped=true&"
import script from "./OtoCoupon.vue?vue&type=script&lang=js&"
export * from "./OtoCoupon.vue?vue&type=script&lang=js&"
import style0 from "./OtoCoupon.vue?vue&type=style&index=0&id=1bb76757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb76757",
  null
  
)

export default component.exports